import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Listens globally for Ctrl+F1 and navigates to the admin login.
 * Replaces the visible "lock" button so the admin entry stays hidden to visitors.
 */
export default function AdminShortcut() {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && (e.key === 'F1' || e.code === 'F1')) {
        e.preventDefault();
        navigate('/admin/login');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  return null;
}
